<template>
  <DsDocumentationSection
    tag="Documentación"
    title="Lo que necesitarás para tu proceso"
    title-id="estrena2-documentation-title"
    description="Reuné esta documentación para que tu proceso avance sin contratiempos."
    :image="documentationDesktopImage"
    :tablet-image="documentationTabletImage"
    :mobile-image="documentationMobileImage"
    image-alt="Casa junto a documentos relacionados con un proceso de compraventa"
    :items="documentationItems"
  />
</template>

<script setup lang="ts">
import documentationTabletImage from '../../../../../assets/estrena2/estrena2-documentation-tablet.webp'
import documentationDesktopImage from '../../../../../assets/estrena2/estrena2-documentation-desktop.webp'
import documentationMobileImage from '../../../../../assets/estrena2/estrena2-documentation-mobile.webp'
import documentIcon from '../../../../../assets/estrena2/icon container_Portal del cliente.svg'
import incomeIcon from '../../../../../assets/estrena2/income.svg'
import identificationIcon from '../../../../../assets/estrena2/Vector (2).svg'
import paymentsInformationIcon from '../../../../../assets/estrena2/Vector (3).svg'
import DsDocumentationSection from '../components/DsDocumentationSection.vue'

const documentationItems = [
  {
    id: 'income',
    iconSrc: incomeIcon,
    text: 'Comprobantes de ingresos'
  },
  {
    id: 'identification',
    iconSrc: identificationIcon,
    iconWidth: 20,
    iconHeight: 16,
    text: 'Identificación oficial'
  },
  {
    id: 'property-documents',
    iconSrc: documentIcon,
    text: 'Documentación relacionada con el inmueble'
  },
  {
    id: 'seller-payments',
    iconSrc: paymentsInformationIcon,
    iconWidth: 22,
    iconHeight: 16,
    text: 'Información de los pagos realizados al vendedor'
  }
]
</script>
